/* WP-10 error text (§14.7): map PORTAL_* codes to concierge i18n sentences. */
import type { TFunction } from 'i18next';
import { isPortalApiError } from '../api/portal-api';

export function errorText(err: unknown, t: TFunction): string {
  if (isPortalApiError(err)) {
    const key = `errors.${err.code}`;
    const translated = t(key);
    if (translated !== key) return translated;
    if (err.code === 'PORTAL_VALIDATION_FAILED' && err.details) {
      return t('errors.PORTAL_VALIDATION_FAILED');
    }
    return t('errors.GENERIC');
  }
  if (err instanceof TypeError && /fetch|network/i.test(err.message)) {
    return t('errors.NETWORK');
  }
  return t('errors.GENERIC');
}
